// NavBarNMenu translations

export const _translations = {
	legacy: false,
	locale: 'de',
	messages: {
		en: {
			menu: {
				base: 'General',
				admin: 'Admin',
				developer: 'Developer',
				projects: 'Projects',
				settings: 'Settings',
				main: 'Main',
				Home: 'Home',
				Projects: 'Projects',
				Users: 'Users',
				AuthUserProfile: 'Account',
				Locations: 'Locations',
				Hubs: 'Hubs',
				Graphs: 'Graphs',
				Comapps: 'Comapps',
				Yocto: 'YoctoWS',
				IPCalls: 'IPCalls',
				Admin: 'Admin',
				ChangeLogs: 'ChangeLogs',
				AlertMatrix: 'Alert Matrix',
				AlertMatrixByUser: 'Alert Matrix User',
				AlertMatrixForGraphs: 'Alert Matrix Equations',
				Inventory: 'Inventory',
				updateAvailable: 'Update available',
			},
			layout: {
				common: {
					close: 'Close',
				},
				search: {
					label: 'Search',
					placeholder: 'Search',
					actionsTitle: 'Actions',
					createFolder: 'Create a new folder',
					uploadDocument: 'Upload new document',
					inviteToProject: 'Invite to project',
					quickLinksTitle: 'Quick Links',
					fileManager: 'File Manager',
					profile: 'Profile',
					dashboard: 'Dashboard',
					support: 'Support',
					keyboardShortcuts: 'Keyboard Shortcuts',
				},
				language: {
					english: 'English',
					german: 'Deutsch',
				},
				userMenu: {
					profile: 'My Profile',
					settings: 'Settings',
					logout: 'Logout',
				},
				notifications: {
					title: 'Notification',
					today: 'Today',
					previous: 'Previous',
					items: {
						returnRequested: 'Customer has requested a return for item',
						reviewSubmitted: 'A new review has been submitted for product',
						weekendPromotion: 'Prepare for the upcoming weekend promotion',
						stockLow: "Product 'ABC123' is running low in stock.",
						paymentReceived: 'Payment received for Order ID: #67890',
					},
					times: {
						hourAgo: '1 Hour ago',
						twoDaysAgo: '2 Days ago',
						threeDaysAgo: '3 Days ago',
						weekAgo: 'Week ago',
					},
					actions: {
						markRead: 'Mark as read',
						viewAll: 'View All',
					},
				},
				sideDrawer: {
					title: 'Settings',
					reset: 'Reset',
					fullScreen: 'Full Screen',
					closeSidebar: 'Close sidebar',
					theme: 'Theme',
					sidebar: 'Sidebar',
					onlyLightContrast: '(*Only available in light, contrast themes)',
					direction: 'Direction',
				},
				theme: {
					light: 'Light',
					contrast: 'Contrast',
					material: 'Material',
					dark: 'Dark',
					dim: 'Dim',
					system: 'System',
				},
				direction: {
					ltrLong: 'Left to Right',
					rtlLong: 'Right to Left',
					ltrShort: 'LTR',
					rtlShort: 'RTL',
				},
				panel: {
					graphs: 'Graphs',
					modules: 'Modules',
					comapps: 'ComApps',
					newGraph: 'New Graph',
					noModules: 'No Modules',
					noComapps: 'No ComApps',
				},
				meganav: {
					searchPlaceholder: 'Projects',
					settings: 'Settings',
					showArchived: 'Show archived projects',
				},
				versionUpdate: {
					tooltip: 'Current: v{current} → New: v{remote}',
					textBefore: 'New version available,',
					textLink: 'CLICK HERE',
					textAfter: '!',
				},
			},
		},
		de: {
			menu: {
				base: 'Allgemein',
				admin: 'Admin',
				developer: 'Entwickler',
				projects: 'Projekte',
				settings: 'Einstellungen',
				main: 'Main',
				Home: 'Karte',
				Projects: 'Projekte',
				Users: 'Benutzer',
				AuthUserProfile: 'Konto',
				Locations: 'Orte',
				Hubs: 'Hubs',
				Graphs: 'Graphen',
				Comapps: 'Comapps',
				Yocto: 'YoctoWS',
				IPCalls: 'IPCalls',
				Admin: 'Admin',
				ChangeLogs: 'Änderungs-Logs',
				AlertMatrix: 'Alarm Matrix',
				AlertMatrixByUser: 'Alarm Matrix Benutzer',
				AlertMatrixForGraphs: 'Alarm Matrix Glgn.',
				Inventory: 'Inventar',
				updateAvailable: 'Update verfügbar',
			},
			layout: {
				common: {
					close: 'Schließen',
				},
				search: {
					label: 'Suche',
					placeholder: 'Suchen',
					actionsTitle: 'Aktionen',
					createFolder: 'Neuen Ordner erstellen',
					uploadDocument: 'Neues Dokument hochladen',
					inviteToProject: 'Zum Projekt einladen',
					quickLinksTitle: 'Schnellzugriff',
					fileManager: 'Dateimanager',
					profile: 'Profil',
					dashboard: 'Dashboard',
					support: 'Support',
					keyboardShortcuts: 'Tastenkürzel',
				},
				language: {
					english: 'Englisch',
					german: 'Deutsch',
				},
				userMenu: {
					profile: 'Mein Profil',
					settings: 'Einstellungen',
					logout: 'Abmelden',
				},
				notifications: {
					title: 'Benachrichtigung',
					today: 'Heute',
					previous: 'Vorherige',
					items: {
						returnRequested: 'Kunde hat eine Rücksendung angefragt',
						reviewSubmitted: 'Neue Bewertung für ein Produkt eingereicht',
						weekendPromotion: 'Wochenendaktion vorbereiten',
						stockLow: "Produkt 'ABC123' hat einen niedrigen Bestand.",
						paymentReceived: 'Zahlung für Bestell-ID: #67890 erhalten',
					},
					times: {
						hourAgo: 'Vor 1 Stunde',
						twoDaysAgo: 'Vor 2 Tagen',
						threeDaysAgo: 'Vor 3 Tagen',
						weekAgo: 'Vor einer Woche',
					},
					actions: {
						markRead: 'Als gelesen markieren',
						viewAll: 'Alle anzeigen',
					},
				},
				sideDrawer: {
					title: 'Einstellungen',
					reset: 'Zurücksetzen',
					fullScreen: 'Vollbild',
					closeSidebar: 'Seitenleiste schließen',
					theme: 'Theme',
					sidebar: 'Seitenleiste',
					onlyLightContrast: '(*Nur verfügbar bei Light- und Contrast-Themes)',
					direction: 'Richtung',
				},
				theme: {
					light: 'Hell',
					contrast: 'Kontrast',
					material: 'Material',
					dark: 'Dunkel',
					dim: 'Gedimmt',
					system: 'System',
				},
				direction: {
					ltrLong: 'Links nach Rechts',
					rtlLong: 'Rechts nach Links',
					ltrShort: 'LNR',
					rtlShort: 'RNL',
				},
				panel: {
					graphs: 'Graphen',
					modules: 'Module',
					comapps: 'ComApps',
					newGraph: 'Neuer Graph',
					noModules: 'Keine Module',
					noComapps: 'Keine ComApps',
				},
				meganav: {
					searchPlaceholder: 'Projekte',
					settings: 'Einstellungen',
					showArchived: 'Archivierte Projekte anzeigen',
				},
				versionUpdate: {
					tooltip: 'Aktuell: v{current} → Neu: v{remote}',
					textBefore: 'Neue Version verfügbar,',
					textLink: 'HIER klicken',
					textAfter: '!',
				},
			},
		},
	},
}
